export type CustomDialogProps = {
  readonly open: boolean;
  readonly onClose: () => void;
};

export enum OrganizationPortalImportJobTypes {
  OrganizationUser = "1BAD660B-43C3-4DB0-95EA-8E8C1084B064",
  OrganizationUserDeactivation = "E004BD7D-6A3D-4FFC-907F-3E00FF3BA31C",
}

export type ImportMode = "add" | "deactivate";

export enum SkuAvailabilityId {
  OnDemand = "7d9ed55d-3919-48ec-9876-2a66e8b85f91",
  Live = "ae00a8f7-bd4c-46d8-a661-b3f6deeea89a",
}

export enum GenericSkuFilterTypeId {
  Qualification = "FF7F6C7F-5942-4003-BDBB-3839C878F6C4",
  Resource = "22694A38-085D-48E2-9045-5E2BF705BA6E",
  Topic = "80696C45-EB89-4B72-A607-88AF2D45A8BA",
  Profession = "A81F7ADB-8102-4F7F-A834-B13C54E0A161",
  CreditHours = "C5D407CD-5C95-4F22-801E-B358C3273EC0",
  State = "8E954D69-D92A-4C79-A1A1-C34EC3B983C2",
  Format = "5E4D52AF-4C11-4A09-A958-F7317EFBA42C",
}

